import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { LegalTextStyles } from '../legal-text-styles';
import AlxButton from '../../../alx-components/button';
import { setPolicyRoute, setShowCookies } from '../../../../store/slices/generalSlice';

const ModalCookies = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['cookies']);
  return (
    <LegalTextStyles>
      <div className="legal-text">
        <h1>{t('cookies:title')}</h1>
        <h2>{t('cookies:subtitle-1')}</h2>
        <p>{t('cookies:text-1')}</p>
        <h2>{t('cookies:subtitle-2')}</h2>
        <h2>{t('cookies:subtitle-3')}</h2>
        <ul>
          <li>{t('cookies:text-2')}</li>
          <li>{t('cookies:text-3')}</li>
        </ul>
        <h2>{t('cookies:subtitle-4')}</h2>
        <ul>
          <li>{t('cookies:text-4')}</li>
          <li>{t('cookies:text-5')}</li>
          <li>{t('cookies:text-6')}</li>
          <li>{t('cookies:text-7')}</li>
        </ul>
        <h2>{t('cookies:subtitle-5')}</h2>
        <ul>
          <li>{t('cookies:text-8')}</li>
          <li>{t('cookies:text-9')}</li>
        </ul>
        <h2>{t('cookies:subtitle-6')}</h2>
        <ul>
          <li>{t('cookies:text-10')}</li>
          <li>{t('cookies:text-11')}</li>
        </ul>
        <p></p>
      </div>
      <AlxButton
        onClick={() => {
          dispatch(setShowCookies({ cookies: 'second' }));
          dispatch(setPolicyRoute({ policy: undefined }));
        }}
      >
        {t('cookies:text-12')}
      </AlxButton>
    </LegalTextStyles>
  );
};

export default ModalCookies;
